const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
const defaultTheme = prefersDark ? 'dark' : 'light'

export default {
  presets: {
    light: {
      primary: '#a628e6',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
    },
    dark: {
      primary: '#a628e6',
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
  currentPresetName: defaultTheme,
}
